import React, { Fragment } from "react";
import ArrowDownIcon from "../../svgs/icoMoon/icons/arrowDown/arrowDown";
import * as actions from "../../../authentication/actions";
import { connect } from "react-redux";
import "./accountMenu.css";
import Button from "../../button/button";
import AccountMenuLinksAuthenticated from "./accountMenuLinksAuthenticated";
import AccountMenuLinksAnonymous from "./accountMenuLinksAnonymous";
import $ from "jquery";
import { COOKIES_ICON } from "../../images";
import { Link } from "react-router-dom";
import { IDENTITY_END_SESSION_URL } from "../../../config";
import { parseOAuthParameters } from "../../../authentication/constants/parse/oauth";

// The image is promoted unchanged from QA to production, so the end-session URL baked into
// globalConfig at build time is QA's. Derive it instead from the authorize URL the Core
// publishes for this environment (authorization-info -> base_url), as the Manager does.
const toEndSessionUrl = (authorizeUrl) =>
  authorizeUrl && /connect\/authorize\/?$/i.test(authorizeUrl)
    ? authorizeUrl.replace(/connect\/authorize\/?$/i, "connect/endsession")
    : null;

class AccountMenu extends React.Component {
  state = {
    open: false,
  };

  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.ensureAuthorizeUrl();
  }

  componentDidUpdate() {
    this.ensureAuthorizeUrl();
  }

  // A session restored from a cookie never ran the login flow's authorization-info call,
  // so fetch it once while logged in; logout needs it to reach the right Identity Server.
  ensureAuthorizeUrl() {
    if (
      this.props.loggedIn &&
      !this.props.authorizeUrl &&
      !this.authorizeUrlRequested
    ) {
      this.authorizeUrlRequested = true;
      this.props.fetchOauthParameters();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      this.state.open
    ) {
      this.dropMenuDown();
    }
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  dropMenuDown = () => {
    $(".usr_drop").slideToggle().focus();
    this.setState({
      open: !this.state.open,
    });
  };

  logout = () => {
    // Environment-specific IdP end-session URL (QA -> myqa.nbg.gr, PROD -> my.nbg.gr),
    // taken from the Core's runtime settings; globalConfig is only a fallback.
    const endSessionUrl =
      toEndSessionUrl(this.props.authorizeUrl) || IDENTITY_END_SESSION_URL;
    if (endSessionUrl) {
      window.open(endSessionUrl, "_blank", "noopener,noreferrer");
    }
    this.props.logout();
    this.props.setManuallLogout(true);
  };

  render() {
    const { loggedIn, userName, className, mobile } = this.props;

    return !mobile ? (
      <div className={className}>
        <Link to="/cookie-settings" className="cookie-settings">
          <img src={COOKIES_ICON} alt="cookie settings" />
          <span>Cookie Settings</span>
        </Link>
        {!(loggedIn && userName) ? (
          <div id="not_loged" className="usr">
            <AccountMenuLinksAnonymous />
          </div>
        ) : (
          <div id="loged" className="usr" ref={this.setWrapperRef}>
            <div className="loged">
              <span className="blueTxt">Welcome </span>
              <Button
                id="account_settings"
                className="usr_arrow"
                onClick={this.dropMenuDown}
              >
                <span className="usr_name">{userName}</span>
                <ArrowDownIcon />
              </Button>
            </div>
          </div>
        )}
        {loggedIn && (
          <div className="usr_drop" style={{ display: "none" }}>
            <AccountMenuLinksAuthenticated
              mobile={mobile}
              logout={this.logout}
            />
          </div>
        )}
      </div>
    ) : (
      <Fragment>
        {loggedIn && userName && (
          <li>
            <div className="mobile-welcome">
              <span>Welcome</span> {userName}
            </div>
          </li>
        )}
        <li className="mobile-signup">
          {loggedIn && userName ? (
            <AccountMenuLinksAuthenticated
              mobile={mobile}
              logout={this.logout}
            />
          ) : (
            <AccountMenuLinksAnonymous mobile={mobile} />
          )}
        </li>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedIn: state.applicationUser?.isLoggedIn,
  userName: state.applicationUser?.name,
  authorizeUrl: parseOAuthParameters(state.applicationUser?.oAuthParameters)
    ?.baseUrl,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => {
    dispatch(actions.logout());
  },
  setManuallLogout: (payload) => {
    dispatch(actions.setManuallLogout(payload));
  },
  fetchOauthParameters: () => {
    dispatch(actions.fetchOauthParameters());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountMenu);
